module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Italic.woff?b19568cfe68ba4ef804424aa3d1c05cb";